import React, { useState } from 'react';
import { Paperclip, ArrowUp, Zap } from 'lucide-react';
interface MessageInputProps {
  onSend: (content: string) => void;
  isTyping?: boolean;
}
export function MessageInput({
  onSend,
  isTyping
}: MessageInputProps) {
  const [content, setContent] = useState('');
  const handleSend = () => {
    if (!content.trim()) return;
    onSend(content);
    setContent('');
  };
  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };
  return <div className="sticky bottom-0 bg-white border-t border-gray-200 px-6 py-4 z-10" data-id="element-120">
      <div className="max-w-4xl mx-auto relative" data-id="element-121">
        <div className="relative flex items-end bg-gray-50 border border-gray-200 rounded-xl shadow-sm focus-within:ring-2 focus-within:ring-blue-100 focus-within:border-blue-300 transition-all" data-id="element-122">
          <button className="p-3 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-123">
            <Paperclip className="h-5 w-5" data-id="element-124" />
          </button>

          <input type="text" value={content} onChange={e => setContent(e.target.value)} onKeyDown={handleKeyDown} placeholder="Message this Space..." className="flex-1 bg-transparent border-none focus:ring-0 py-3.5 text-gray-900 placeholder-gray-400" autoFocus data-id="element-125" />

          <div className="p-2" data-id="element-126">
            <button onClick={handleSend} disabled={!content.trim()} className={`
                p-2 rounded-lg transition-all duration-200
                ${content.trim() ? 'bg-blue-600 text-white shadow-sm hover:bg-blue-700' : 'bg-gray-200 text-gray-400 cursor-not-allowed'}
              `} data-id="element-127">
              <ArrowUp className="h-4 w-4" data-id="element-128" />
            </button>
          </div>
        </div>

        <div className="flex justify-center mt-2" data-id="element-129">
          <p className="text-[10px] text-gray-400 flex items-center" data-id="element-130">
            <Zap className="h-3 w-3 mr-1 text-gray-300" data-id="element-131" />
            Nothing runs without your approval
          </p>
        </div>
      </div>
    </div>;
}